import * as Yup from "yup";
import { lang } from "../Utils/lang";

export const LoginModel = Yup.object().shape({
  email: Yup.string()
    .required(lang.required)
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      lang.invalidEmail
    ),
  password: Yup.string().required(lang.required),
});